import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-13fe4fdc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "notice-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    title: "查看通知",
    modelValue: _ctx.selfVisible,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selfVisible) = $event)),
    "close-on-press-escape": false,
    "close-on-click-modal": false,
    onClose: _ctx.handleClose,
    center: "",
    top: "5vh"
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(_component_el_button, {
          size: "default",
          onClick: _ctx.handleClose
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 返回 ")
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        inline: false,
        "label-width": "110px",
        model: _ctx.formData,
        size: "default"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, { label: "通知编号：" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.formData.noticeCode), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { label: "更新系统：" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.formData.updateSystem.join()), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { label: "同步停服系统：" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.formData.noticeSystem.join()), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { label: "开始通知时间：" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$filters.formatTime(_ctx.formData.publishTime)), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { label: "结束通知时间：" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$filters.formatTime(_ctx.formData.publishEndTime)), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { label: "通知栏：" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.formData.theme), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "具体更新内容：",
            prop: "content"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.noticeContent.content), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _: 1
  }, 8, ["modelValue", "onClose"]))
}